import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

import { parseWellLogsManagerWidgetInternalState } from '../../../pages/dashboard/features/well-logs-manager-widget/parseWellLogsManagerWidget';
import { WellLogsManagerWidgetEntity } from '../../../pages/dashboard/features/well-logs-manager-widget/WellLogsManagerWidget.entity';

export function mapWellLogsManagerTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): WellLogsManagerWidgetEntity {
  const { size, position } = template;

  const internalState = parseWellLogsManagerWidgetInternalState(template.internalState ?? {});

  const wellLogsManagerWidget = new WellLogsManagerWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams,
      type: 'well-logs-manager-widget',
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    },
  );

  return wellLogsManagerWidget;
}
